import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact_parent_div">
      <h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum nulla in
        commodi labore doloribus sunt impedit ipsa itaque dignissimos animi ab
        eveniet, id, rem laborum illo. Vel nihil corporis delectus.
      </h1>
    </div>
  );
};

export default Contact;
